export default () => {
    handleScroll();
    window.addEventListener('scroll', handleScroll);
};

const handleScroll = () => {
    const items = document.querySelectorAll('[data-progress-handler]');

    items.forEach((el) => {
        const rect = el.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        // Calculate when the element starts entering the viewport (top edge at bottom)
        const startPoint = viewportHeight;
        // Calculate when the element is fully scrolled (bottom edge at top)
        const endPoint = -rect.height;

        // Calculate progress from 0 to 1
        let progress = 0;
        if (rect.top <= startPoint) {
            // Element has started entering the viewport
            const totalDistance = startPoint - endPoint;
            const currentDistance = startPoint - rect.top;
            progress = Math.min(Math.max(currentDistance / totalDistance, 0), 1);
        }

        el.style.setProperty('--progress', progress.toFixed(2));
    });
};
